<template>
  <div class="node-right-warp">
    <el-form ref="nodeForm" :model="form" class="nodeForm" label-width="70px"
             :rules="rules" :hide-required-asterisk="true">
      <div class="node-item">
        <div class="tips"><span class="right-line" :class="className=='left'&&'left-line'"></span>实际值大于标准值</div>
        <el-form-item label="触发指令">
          <el-select v-model="form.trigger" prop="trigger" @change="directiveChange">
            <el-option :label="item.dictValue" :value="item.dictCode" v-for="item in optionOperate"
                       :key="item.dictCode"></el-option>
            <!--            <el-option label="直接过滤" value="2"></el-option>-->
          </el-select>
        </el-form-item>
        <el-form-item label="下一指标" prop="indexCode" v-if="form.trigger=='next'">
          <el-select v-model="form.indexCode" @change="nodeChangeHandle">
            <el-option :label="option.name" :value="option.code" v-for="option in pressOption"
                       :key="option.code" :disabled="option.disabled"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标准值" prop="standardValue" v-if="form.trigger=='next'">
          <el-input v-model="form.standardValue" placeholder="请输入" v-if="form.indexCode!='cost'">
            <template slot="append" v-if="indexCodeType">%</template>
          </el-input>
          <el-button plain v-else @click="openCostDialog">查看</el-button>
        </el-form-item>
        <el-form-item label="偏差比例" prop="deviationRate" v-if="form.trigger=='next'">
          <el-input v-model="form.deviationRate" placeholder="请输入">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </div>
      <div class="rightWarp">
        <node-left ref="nodeLeftDom" :list="form.leftNode" :optionSelect="pressOption"
                   :optionOperate="optionOperate" v-if="form.leftNode"
                   className="right" v-bind="$attrs"></node-left>
        <node-right ref="nodeRightDom" :list="form.rightNode" :optionSelect="pressOption"
                    :optionOperate="optionOperate" v-if="form.rightNode"
                    className="left" v-bind="$attrs"></node-right>
        <div style="height:20px;width:1px;background: transparent"></div>
      </div>
    </el-form>
    <cost-dialog ref="costDialogDom" @costDialogHandle="costDialogHandle" v-bind="$attrs" v-if="form.indexCode=='cost'"></cost-dialog>
  </div>

</template>

<script>
    import nodeRightJs from "./nodeRight.js"

    export default nodeRightJs
</script>

<style lang="scss" scoped>
  @import "nodeRight";
</style>



// WEBPACK FOOTER //
// src/pages/recommend/automaticPutin/intellPromotion/component/nodeItem/nodeRight/nodeRight.vue